import React from 'react'
import { withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import howToIcon from 'media/article_list/howto.svg'
import infoBlack from 'media/article_list/info_black.svg'
import activityBlack from 'media/article_list/activity_black.svg'
import lessonBlack from 'media/article_list/lesson_black.svg'
import reflectionBlack from 'media/article_list/reflection_black.svg'
import infoWhite from 'media/article_list/info_white.svg'
import activityWhite from 'media/article_list/activity_white.svg'
import lessonWhite from 'media/article_list/lesson_white.svg'
import reflectionWhite from 'media/article_list/reflection_white.svg'
import SVGInline from 'react-svg-inline/src'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import SvgBook from './icons/book'

const styles = theme => ({
  howToBar: {
    backgroundColor: '#D58F6D',
    width: '100%',
    textAlign: 'center',
    height: 100,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center'
  },
  howToBarInner: {
    color: 'white',
    fontSize: 22,
    fontWeight: 'bold',
    fontStyle: 'normal',
    lineHeight: 1.64,
    textTransform: 'uppercase',
    padding: 20,
    display: 'inline-flex',
  },
  howToIcon: {
    display: 'inline-flex',
  },
  howtoContainer: {},
  howtoLeft: {
    width: '50%',
    display: 'inline-block'
  },
  howtoRight: {
    width: '50%',
    display: 'inline-block'
  },
  paper: {
    minWidth: 960
  },
  dialogContainer: {
    minWidth: 960
  },
  leftText: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.22)',
    backgroundColor: '#CA8456',
    color: 'white',
    margin: 30,
    fontSize: 16,
    padding: 20
  },
  rightText: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.22)',
    color: 'black',
    margin: 20,
    display: 'flex',
    fontSize: 16,
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center'

  },
  rightTextInner: {
    display: 'inline-flex',
    fontSize: 16,
    padding: 10,
  },
  iconsContainer: {
    borderRadius: 19,
    backgroundColor: '#d80000',
    color: 'white',
    textAlign: 'center',
    margin: 20
  },
  goToTools: {
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
    padding: 10,
    fontSize: 20,
    width: 300,
    margin: 'auto'
  },
  helpIcon: {
    height: '100%',
    display: 'inline-flex',
    color: 'black',
    margin: 10,
  },
  bookIcon: {
    width: 50,
    height: 50
  },
  toolsIconsSystem: {
    width: 420,
    display: 'flex',
    fontSize: 23,
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#d80000',
    color: 'white',
    margin: 'auto'
  },
  toolsIconsSystemInner: {
    color: 'white',
    fontSize: 23,
  }, howToContainer: {

    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center'
  }, howToContainerWithTitles: {
    width: '50%',
    right: 0,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: 20,

  },
  topicsContainer: {
    width: '50%',
    textTransform: 'uppercase',
    color: 'white',
    display: 'flex',
  },
  topicsList: {
    display: 'flex',
    // flexDirection: 'column',
    // flexWrap: 'wrap',
    flexFlow: 'column wrap',
    height: 100,
    fontSize: 13,
    alignContent: 'flex-start',
    justifyContent: 'space-around',
  },
  topicsListItem: {
    display: 'inline-flex',
    padding: 3,
    margin: '0px 20px',
  },
  topics: {
    transform: 'rotate(-180deg)',
    writingMode: 'vertical-rl',
    letterSpacing: 2,
    fontSize: 16,
    fontWeight: 'bold',
    margin: '10px 20px',
  },
})

class HowToUseInner extends React.Component {
  state = {
    modalOpen: false,
  }

  openHowToModal () {
    this.setState({ modalOpen: true })
  }

  handleClose () {
    this.setState({ modalOpen: false })
  }

  render () {
    let {
      classes,
      topics
    } = this.props
    topics = null
    return <div className={classes.howToBar}>
      {topics ? <div className={classes.topicsContainer}>
        <div className={classes.topics}>
          Titles
        </div>
        <ol className={classes.topicsList}>
          {topics.map((item, index) => {
            return <li className={classes.topicsListItem} key={index}> {item}</li>
          })}

        </ol>
      </div> : ''}

      <div className={topics ? classes.howToContainerWithTitles : classes.howToContainer}>
        <Typography className={classes.howToBarInner}>
          How to use the tool?
        </Typography>
        <SVGInline svg={howToIcon} className={classes.howToIcon} onClick={() => this.openHowToModal()}
                   height='75px'/>
      </div>
      <Dialog open={this.state.modalOpen}
              onClose={() => this.handleClose()}
              scroll='paper'
              className={classes.dialogContainer}
              maxWidth={'md'}
      >
        <DialogContent className={classes.dialogContainer}>
          {/*<div className={classes.paper}>*/}
          <div className={classes.toolsIconsSystem}>
            {/*<SVGInline svg={book} height={50} width={50} fill={'#fff'}/>*/}
            <SvgBook className={classes.bookIcon}/>
            <Typography className={classes.toolsIconsSystemInner}>
              TOOLS ICONS SYSTEM
            </Typography>
          </div>
          <div className={classes.howtoContainer}>
            <div className={classes.howtoLeft}>
              <div className={classes.leftText}>
                While using our TOOLS, you will encounter those icons.
              </div>
              <div className={classes.iconsContainer}>
                <SVGInline svg={infoWhite} className={classes.helpIcon} height="75px" width="75px" fill={'#fff'}/>
                <SVGInline svg={activityWhite} className={classes.helpIcon} height="75px" width="75px" fill={'#fff'}/>
                <SVGInline svg={lessonWhite} className={classes.helpIcon} height="75px" width="75px" fill={'#fff'}/>
                <SVGInline svg={reflectionWhite} className={classes.helpIcon} height="75px" width="75px" fill={'#fff'}/>
              </div>
              <div className={classes.leftText}>
                They will appear after going to next step, or hovering over certain elements.
              </div>
              <div className={classes.leftText}>
                They are used to guide you through next steps of experience.
              </div>
            </div>
            <div className={classes.howtoLeft}>
              <div className={classes.rightText}>
                <SVGInline svg={infoBlack} className={classes.helpIcon} height="75px" width="75px" fill={'#000'}/>
                <Typography className={classes.rightTextInner}>
                  This section introduce you to topic of the lesson.
                </Typography>
              </div>
              <div className={classes.rightText}>
                <SVGInline svg={activityBlack} className={classes.helpIcon} height="75px" width="75px" fill={'#000'}/>
                <Typography className={classes.rightTextInner}>
                  Activities are simple exercises, designed for introduced topic.
                </Typography>
              </div>
              <div className={classes.rightText}>
                <SVGInline svg={lessonBlack} className={classes.helpIcon} height="75px" width="75px" fill={'#000'}/>
                <Typography className={classes.rightTextInner}>
                  Lesson gives you next portion of information about topic.
                </Typography>
              </div>
              <div className={classes.rightText}>
                <SVGInline svg={reflectionBlack} className={classes.helpIcon} height='75px' width="75px" fill={'#000'}/>
                <Typography className={classes.rightTextInner}>
                  Reflection provide you questions, so you can debate and reflect on the topic.
                </Typography>
              </div>
            </div>
            {/*<div className={classes.goToTools}>*/}
            <Typography className={classes.goToTools}>
              GO TO THE TOOLS
            </Typography>

            {/*</div>*/}
          </div>
          {/*</div>*/}
        </DialogContent>
      </Dialog>
    </div>
  }
}

const HowToUse = withStyles(styles)(HowToUseInner)
export default HowToUse
